import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'utils/apolloWrapper';
const defaultOptions = {} as const;
export type ProductItemFragment = { __typename?: 'Product', id: string, name: string, level: Types.ProductLevel, isPackage?: boolean | null, parent?: { __typename?: 'Product', id: string, parent?: { __typename?: 'Product', id: string, parent?: { __typename?: 'Product', id: string } | null } | null } | null };

export type WithAdminProductFragment = { __typename?: 'Product', adminProduct?: { __typename?: 'AdminProduct', id: string, name: string } | null };

export type ProductTreeQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.ProductFilter>;
  withAdminProduct?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  roleId?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ProductTreeQuery = { __typename?: 'Query', products: { __typename?: 'Products', treeRestricted: Array<{ __typename?: 'Product', id: string, name: string, level: Types.ProductLevel, isPackage?: boolean | null, children?: Array<{ __typename?: 'Product', id: string, name: string, level: Types.ProductLevel, isPackage?: boolean | null, children?: Array<{ __typename?: 'Product', id: string, name: string, level: Types.ProductLevel, isPackage?: boolean | null, children?: Array<{ __typename?: 'Product', id: string, name: string, level: Types.ProductLevel, isPackage?: boolean | null, parent?: { __typename?: 'Product', id: string, parent?: { __typename?: 'Product', id: string, parent?: { __typename?: 'Product', id: string } | null } | null } | null, adminProduct?: { __typename?: 'AdminProduct', id: string, name: string } | null }> | null, parent?: { __typename?: 'Product', id: string, parent?: { __typename?: 'Product', id: string, parent?: { __typename?: 'Product', id: string } | null } | null } | null, adminProduct?: { __typename?: 'AdminProduct', id: string, name: string } | null }> | null, parent?: { __typename?: 'Product', id: string, parent?: { __typename?: 'Product', id: string, parent?: { __typename?: 'Product', id: string } | null } | null } | null, adminProduct?: { __typename?: 'AdminProduct', id: string, name: string } | null }> | null, parent?: { __typename?: 'Product', id: string, parent?: { __typename?: 'Product', id: string, parent?: { __typename?: 'Product', id: string } | null } | null } | null, adminProduct?: { __typename?: 'AdminProduct', id: string, name: string } | null }> } };

export const ProductItemFragmentDoc = gql`
    fragment ProductItem on Product {
  id
  name
  level
  isPackage
  parent {
    id
    parent {
      id
      parent {
        id
      }
    }
  }
}
    `;
export const WithAdminProductFragmentDoc = gql`
    fragment WithAdminProduct on Product {
  adminProduct {
    id
    name
  }
}
    `;
export const ProductTreeDocument = gql`
    query ProductTree($filter: ProductFilter, $withAdminProduct: Boolean = false, $roleId: String) {
  products {
    treeRestricted(filter: $filter, roleId: $roleId) {
      ...ProductItem
      ...WithAdminProduct @include(if: $withAdminProduct)
      children {
        ...ProductItem
        ...WithAdminProduct @include(if: $withAdminProduct)
        children {
          ...ProductItem
          ...WithAdminProduct @include(if: $withAdminProduct)
          children {
            ...ProductItem
            ...WithAdminProduct @include(if: $withAdminProduct)
          }
        }
      }
    }
  }
}
    ${ProductItemFragmentDoc}
${WithAdminProductFragmentDoc}`;

/**
 * __useProductTreeQuery__
 *
 * To run a query within a React component, call `useProductTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductTreeQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      withAdminProduct: // value for 'withAdminProduct'
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useProductTreeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProductTreeQuery, ProductTreeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductTreeQuery, ProductTreeQueryVariables>(ProductTreeDocument, options);
      }
export function useProductTreeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductTreeQuery, ProductTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductTreeQuery, ProductTreeQueryVariables>(ProductTreeDocument, options);
        }
// @ts-ignore
export function useProductTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProductTreeQuery, ProductTreeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductTreeQuery, ProductTreeQueryVariables>;
export function useProductTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductTreeQuery, ProductTreeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductTreeQuery | undefined, ProductTreeQueryVariables>;
export function useProductTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductTreeQuery, ProductTreeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProductTreeQuery, ProductTreeQueryVariables>(ProductTreeDocument, options);
        }
export type ProductTreeQueryHookResult = ReturnType<typeof useProductTreeQuery>;
export type ProductTreeLazyQueryHookResult = ReturnType<typeof useProductTreeLazyQuery>;
export type ProductTreeSuspenseQueryHookResult = ReturnType<typeof useProductTreeSuspenseQuery>;
export type ProductTreeQueryResult = Apollo.QueryResult<ProductTreeQuery, ProductTreeQueryVariables>;